import EliteService from '@/elite-lib-yt/service/EliteService.js';
import retry from "@/utils/retry.js";

const getAccessToken = () => localStorage.getItem('token');

const service = new EliteService({
    authToken: getAccessToken,
    refreshToken: retry,
    other: "",
    baseUrl: process.env.VUE_APP_API_URL
});
export default service;
